import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatMoney } from '@transferwise/formatting';
import { FormattedMessage } from 'react-intl';
import { isWiseQuote } from '../../domain/Quote';
import FeeMakeupPopover from '../fee-makeup-popover';
import componentStyles from './HiddenFeeAndPopover.module.less';
var HiddenFeeLabelVariant;
(function (HiddenFeeLabelVariant) {
    HiddenFeeLabelVariant["Good"] = "good";
    HiddenFeeLabelVariant["Bad"] = "bad";
    HiddenFeeLabelVariant["GoodDark"] = "good--dark";
})(HiddenFeeLabelVariant || (HiddenFeeLabelVariant = {}));
const HiddenFeeAndPopover = ({ hiddenFee, quote, midmarketRate, isFeaturedRow, onPopoverClick, open, onClose, }) => {
    return (_jsxs("div", Object.assign({ className: componentStyles.hiddenFeeAndPopover }, { children: [_jsx(HiddenFeeLabelInternal, { variant: hasHiddenFee(hiddenFee)
                    ? HiddenFeeLabelVariant.Bad
                    : isWiseQuote(quote)
                        ? HiddenFeeLabelVariant.GoodDark
                        : HiddenFeeLabelVariant.Good, darkMode: isFeaturedRow, message: hasHiddenFee(hiddenFee) ? (_jsx(FormattedMessage, { id: "hidden-fees-new", values: {
                        hiddenFee: printMoney(hiddenFee),
                        label: (chunks) => (_jsx("span", Object.assign({ className: cssClass('hiddenFee-label') }, { children: chunks }))),
                    } })) : (_jsx(FormattedMessage, { id: "no-hidden-fees" })) }), _jsx(FeeMakeupPopover, { quote: quote, midmarketRate: midmarketRate, isFeaturedRow: isFeaturedRow, onPopoverClick: onPopoverClick, open: open, onClose: onClose })] })));
};
const HiddenFeeLabelInternal = ({ variant, darkMode, message, }) => (_jsx("div", Object.assign({ className: cssClass('hiddenFee-row') }, { children: _jsxs("p", Object.assign({ className: cssClass('hiddenFee-paragraph', darkMode) }, { children: [_jsx("span", { className: cssClass(`hiddenFee-dot--${variant}`) }), _jsx("span", { children: message })] })) })));
const cssClass = (className, darkMode = false) => componentStyles[`${className}${darkMode ? '--dark' : ''}`];
const hasHiddenFee = (hiddenFee) => hiddenFee.value > 0;
const printMoney = (value) => formatMoney(parseFloat(value.value.toFixed(5)), value.currency);
export default HiddenFeeAndPopover;
